export default __webpack_public_path__ + "static/insurance-d1a688e03850eaead3ee6e417b3bff41.png";